module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5kByR"))).then(() => parcelRequire('2KbAe'));